import Vue from 'vue'
import amplitude from 'amplitude-js'

const AnalyticsPlugin = {
  install(Vue) {
    amplitude.getInstance().init(process.env.AMPLITUDE_ID)

    function _setProperty(props, method) {
      const identify = new amplitude.Identify()

      Object.entries(props).forEach(([key, value]) =>
        identify[method](key, value)
      )

      amplitude.getInstance().identify(identify)
    }

    Vue.prototype.$analytics = {
      setUserId(userId) {
        amplitude.getInstance().setUserId(userId)
      },

      sendEvent(eventName, eventProperties) {
        amplitude.getInstance().logEvent(eventName, eventProperties)
      },

      setProperty(props) {
        _setProperty(props, 'set')
      },

      setOnceProperty(props) {
        _setProperty(props, 'setOnce')
      },

      setAddProperty(props) {
        _setProperty(props, 'add')
      },
    }
  },
}

Vue.use(AnalyticsPlugin)
